export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-battery-empty-2d26b19dc2a8e58d5f01585747b0c4be.svg";